import React from "react";
import { Table } from "react-bootstrap";
import { Loader } from "./Loader";
import { BASE_URL } from "../store/constant";
import Axios from "axios";
import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";
import _ from 'lodash'
import { toast } from "react-toastify";
import styled from "styled-components";
import moment from "moment";
import { exportTableToExcel } from '../utils'

const Wrapper = styled.div`
  position: relative;
  & h3 {
    text-align: center;
    display: none;
  }

  @media print {
    h3 {
      display: block;
    }
  }

  table {
  width: 100%;
  border-collapse: separate ;
  border-spacing: 0;
  border: 1px solid #e6e6e6;   /*  light outer border */
  background-color: #ffffff;

}
  
 * {
  box-sizing: border-box;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}


 td{
  text-align:left;
  }
  /* wrap long city names only */
  .city-name{
    max-width: 220px;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
tr td:first-child{
  text-align: center;
  max-width: 70px;
  }
  tbody tr:hover {
    background-color: #d0e4ff;
   
  }
  

`;

class ComponentList extends React.Component {
  theadRef = React.createRef();
  state = {
    isLoading: true,
    BeneficiariesDetail: [],
    excesProjectWithExcludeComponent: [],
    excesProjectInCaseOfCity: [],
    ScoreCard: '',
    headerHeight: 0,
  };

  componentDidMount = async () => {
    this.setState({ isLoading: true });
    console.log('props in beneficiary list-->>>', this.props);
// slicetype
      console.log('props in beneficiary list-->>>',get(this.props, "slicetype"));
      console.log('this.props.constituency',this.props.constituency)

      // &SchemesdataFilterType=${get(this.props, "SchemesdataFilterType")}
    try {

      if (get(this.props, "graphtype") === "Sanctioned") {

      if(this.props.dataFilterType === "constituency"){
       if (this.props.assembly) {
          console.log('in assembly-->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/assembly/${this.props.assembly.value}`
          );
          console.log('data-assembly->>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        } else {
          console.log('in constituency-->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/constituency/${this.props.constituency.value}`
          );
          console.log('data--constituency >>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        }

      } else{
      if (this.props.isDist) {
          console.log('in dist-->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/district/${this.props.districtCode.value}`
          );
          console.log('data-->>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        } else {
          console.log('in city-->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/City/${this.props.cityCode.value}`
          );
          console.log('data--City >>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });


        }

      }

      }
      if (get(this.props, "graphtype") === "Grounded") {

       if(this.props.dataFilterType === "constituency"){
       if (this.props.assembly) {
          console.log('in assembly- Grounded->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/assembly/${this.props.assembly.value}`
          );
          console.log('data-assembly->>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        } else {
          console.log('in constituency--Grounded->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/constituency/${this.props.constituency.value}`
          );
          console.log('data--constituency >>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        }

      }else{
        if (this.props.isDist) {
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/district/${this.props.districtCode.value}`
          );
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        } else {
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/City/${this.props.cityCode.value}`
          );
          this.setState({ BeneficiariesDetail: data, isLoading: false });


        }
        }


      }


    if (get(this.props, "graphtype") === "Completed") {

      if(this.props.dataFilterType === "constituency"){
       if (this.props.assembly) {
          console.log('in assembly- Grounded->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/assembly/${this.props.assembly.value}`
          );
          console.log('data-assembly->>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        } else {
          console.log('in constituency--Grounded->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/constituency/${this.props.constituency.value}`
          );
          console.log('data--constituency >>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        }

      }else{

   if (this.props.isDist) {
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/district/${this.props.districtCode.value}`
          );
          this.setState({ BeneficiariesDetail: data, isLoading: false });

        } else {
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/City/${this.props.cityCode.value}`
          );
          this.setState({ BeneficiariesDetail: data, isLoading: false });
        }


      }

     




      }

        if (get(this.props, "graphtype") === "HousesSanctioned") {

        if (this.props.isDist) {
          console.log('in dist-->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/district/${this.props.districtCode.value}`
          );
          console.log('data-->>>', data);
          this.setState({ BeneficiariesDetail: _.filter(data, (o) => o.component === get(this.props, "slicetype"))  , isLoading: false });

        } else {
          console.log('in city-->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/City/${this.props.cityCode.value}`
          );
          console.log('data--City >>>', data);
          this.setState({ BeneficiariesDetail:  _.filter(data, (o) => o.component === get(this.props, "slicetype")), isLoading: false });


        }



      }

      if (get(this.props, "graphtype") === "BeneficiariesunderCLSS") {

        if (this.props.isDist) {
          if (get(this.props, "slicetype") === "MIG") {
          console.log('in dist-->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/BeneficiariesunderCLSS/MIG/district/${this.props.districtCode.value}`
          );
          console.log('data-->>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });
          }else{
           console.log('in dist-->>>');
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/BeneficiariesunderCLSS/EWS/district/${this.props.districtCode.value}`
          );
          console.log('data-->>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

          }
       

        } else {

          if (get(this.props, "slicetype") === "MIG") {
         console.log('in city-->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/BeneficiariesunderCLSS/MIG/City/${this.props.cityCode.value}`
          );
          console.log('data--City >>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

          }else{
         console.log('in city-->>>');

          const { data } = await Axios.get(
            `${BASE_URL}/project-details/BeneficiariesunderCLSS/EWS/City/${this.props.cityCode.value}`
          );
          console.log('data--City >>>', data);
          this.setState({ BeneficiariesDetail: data, isLoading: false });

          }
       


        }


      }

    } catch (err) {
      this.setState({ isLoading: false });
      toast.error("Something went wronge.");
    }

    // measure header after first mount
    this.updateHeaderHeight();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isLoading !== this.state.isLoading || prevState.BeneficiariesDetail !== this.state.BeneficiariesDetail) {
      this.updateHeaderHeight();
    }
  }
 // code from CustomTable to measure header height --------------------krishna
  updateHeaderHeight = () => {
    try {
      const el = this.theadRef && this.theadRef.current;
      if (el) {
        const h = el.clientHeight || el.offsetHeight || 0;
        if (this.state.headerHeight !== h) this.setState({ headerHeight: h });
      }
    } catch (e) {
      // ignore measurement errors
    }
  }

  render() {
    const { isLoading, BeneficiariesDetail } = this.state;
    const hideColumn = get(this.props, "hideColumn") ? get(this.props, "hideColumn") : [];


    return (
      <Wrapper>
        <h3>Beneficiaries List . {get(this.props, "CSMCNo")}</h3>
        <>
          <div style={{ position: 'relative', maxHeight: '60vh', overflowY: 'auto' }}>
            <Table className="bg-c-white customTable" id="MonitoringofProgress" style={{ minHeight: isLoading ? 360 : undefined }}>

                <thead
                  ref={this.theadRef}
                  className="label label-warning text-white text-center"
                  style={{ backgroundColor: "#002b49", position: 'sticky', top: 0, zIndex: 10 }}
                >
                  <tr style={{ textAlign: "center" }}>
                   {/*  <th rowSpan={2} style={{ width: 30, maxWidth: 30 }} className="center">
                      Sr.
                    </th> */}
                    <th rowSpan={2}>Sanctioned <br/> Date</th>
                    <th rowSpan={2}>District Name</th>
                    <th rowSpan={2}>ULB Name</th>
                    <th rowSpan={2}>Beneficiaries Name</th>
                    <th rowSpan={2}>Father's Name</th>
                    <th rowSpan={2}>Gender</th>
                  {/*   <th rowSpan={2}>Age</th> */}
                 {/*    <th rowSpan={2}>Religion</th> */}
                   <th rowSpan={2}>Component</th>
                  </tr>
                </thead>








              <tbody>
                {map(BeneficiariesDetail, (obj, i) => {
                  return (
                    <tr key={get(obj, "ProjectCode")}>

                    

                {/* https://dashboard.pmay-urban.gov.in/v1/beneficiary/mis_BeneficiaryProfiles?benefCode=018000481486200021 */}


                      <td>{get(obj, "SanctionedDate") || '-'}</td>
                      <td>{get(obj, "DistrictName") || '-'}</td>
                      <td className="city-name">{get(obj, "CityName") || '-'}</td>
                      {get(obj, "component")==='BLC' || get(obj, "component")==='AHP' || get(obj, "component")==='ISSR' ?
                      <td>
                          <a
                        title={_.get(obj, "BeneficiaryName")}
                        target="_blank"
                        rel='noopener noreferrer'
                        href={`/admin-services/NHB_CLSS_BeneficiaryReport?benefCode=${_.get(obj, "BeneficiaryCode")}`}
                      >   
                       {get(obj, "BeneficiaryName") || '-'}
                      </a>
                        
                      </td>:
                      get(obj, "component")==='CLSS' ?
                         <td>
                          <a
                        title={_.get(obj, "BeneficiaryName")}
                        target="_blank"
                        rel='noopener noreferrer'
                        href={`/admin-services/NHB_Beneficiary_ReportForCLSS?beneficiaryCode=${_.get(obj, "BeneficiaryCode")}`}
                      >   
                       {get(obj, "BeneficiaryName") || '-'}
                      </a>
                        
                      </td>
                      :
                      <td>
                            
                       {get(obj, "BeneficiaryName") || '-'}
                      
                        
                      </td>
                    
                    }
                      <td>{get(obj, "FatherName") || '-'}</td>
                      <td>{get(obj, "Gender") || '-'}</td>
                      <td>{get(obj, "component") || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {isLoading && (
              (() => {
                const overlayTop = this.state.headerHeight && this.state.headerHeight > 0 ? this.state.headerHeight : 48;
                return (
                  <div style={{ position: 'absolute', top: overlayTop, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.93)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5 }}>
                    <Loader title="Report Generating..." />
                  </div>
                );
              })()
            )}
          </div>
        </>
      </Wrapper>
    );
  }
}

export default ComponentList;
